<template>
  <footer class="footer">
    <div class="footer-links">
      <router-link to="/datenschutz">Datenschutz</router-link> - 
      <router-link to="/Impressum">Impressum</router-link> - 
      <router-link to="/kontakt">Kontakt</router-link>
    </div>
    <div class="footer-copyright">
      Copyright &copy; 2025 Maike Röhrig - Maikes Familienbegleitung. Alle Rechte vorbehalten.
    </div>
    <div class="footer-social">
      <a href="https://www.instagram.com/maikes_familienbegleitung" aria-label="Maikes Familienbegleitung bei Instagram">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" role="img" aria-label="Instagram-Symbol">
          <g>
            <path d="M12,9c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.7,0,3-1.3,3-3C15,10.3,13.6,9,12,9z">
            </path>
            <path d="M20,0H4C1.8,0,0,1.8,0,4v16c0,2.2,1.8,4,4,4h16c2.2,0,4-1.8,4-4V4C24,1.8,22.2,0,20,0z M20.9,15.7c0,0.7-0.2,1.5-0.4,2.2
              c-0.5,1.2-1.4,2.2-2.6,2.6c-0.7,0.3-1.4,0.4-2.2,0.4c-1,0-1.3,0.1-3.7,0.1s-2.8,0-3.7-0.1c-0.7,0-1.5-0.2-2.2-0.4
              c-1.2-0.5-2.2-1.4-2.6-2.6c-0.3-0.7-0.4-1.4-0.4-2.2C3,14.8,3,14.4,3,12s0-2.8,0.1-3.7c0-0.7,0.2-1.5,0.4-2.2
              c0.5-1.2,1.4-2.2,2.6-2.6c0.7-0.3,1.4-0.4,2.2-0.4C9.2,3,9.6,3,12,3s2.8,0,3.7,0.1c0.7,0,1.5,0.2,2.2,0.4c1.2,0.5,2.2,1.4,2.6,2.6
              c0.3,0.7,0.4,1.4,0.4,2.2c0,1,0.1,1.3,0.1,3.7S21,14.8,20.9,15.7z">
            </path>
            <path d="M19.3,8.4c0-0.6-0.1-1.1-0.3-1.7c-0.1-0.4-0.4-0.7-0.7-1c-0.3-0.3-0.6-0.5-1-0.7c-0.5-0.2-1.1-0.3-1.7-0.3
              c-0.9,0-1.2-0.1-3.6-0.1c-2.4,0-2.7,0-3.6,0.1C7.8,4.7,7.2,4.8,6.7,5c-0.4,0.1-0.7,0.4-1,0.7C5.4,5.9,5.1,6.3,5,6.7
              C4.8,7.2,4.7,7.8,4.7,8.4c0,0.9-0.1,1.2-0.1,3.6c0,2.4,0,2.7,0.1,3.6c0,0.6,0.1,1.1,0.3,1.7c0.1,0.4,0.4,0.7,0.7,1
              c0.3,0.3,0.6,0.5,1,0.7c0.5,0.2,1.1,0.3,1.7,0.3c0.9,0,1.2,0.1,3.6,0.1c2.4,0,2.7,0,3.6-0.1c0.6,0,1.1-0.1,1.7-0.3
              c0.4-0.1,0.7-0.4,1-0.7c0.3-0.3,0.5-0.6,0.7-1c0.2-0.5,0.3-1.1,0.3-1.7l0,0c0-0.9,0.1-1.2,0.1-3.6C19.4,9.6,19.4,9.3,19.3,8.4z
              M12,16.6c-2.6,0-4.6-2.1-4.6-4.6S9.4,7.4,12,7.4c2.6,0,4.6,2.1,4.6,4.6C16.6,14.6,14.5,16.6,12,16.6z M16.8,8.3
              c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1C17.9,7.8,17.4,8.3,16.8,8.3z">
            </path>
          </g>
        </svg>
      </a>
      <a href="mailto:info@maikes-familienbegleitung.de" aria-label="E-Mail an Maikes Familienbegleitung">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" role="img" aria-label="E-Mail-Symbol">
          <path d="M20,24H4c-2.2,0-4-1.8-4-4V4c0-2.2,1.8-4,4-4h16c2.2,0,4,1.8,4,4v16C24,22.2,22.2,24,20,24z M4,3
            C2.8,3.1,1.9,4.1,2,5.3l0,13.5c-0.1,1.2,0.8,2.2,2,2.3h16c1.2-0.1,2.1-1.1,2-2.3V5.3c0.1-1.2-0.8-2.2-2-2.3H4z M12,13.1L12,13.1
            L4,7.5V5.3l8,5.6l8-5.6v2.3L12,13.1L12,13.1z">
          </path>
        </svg>
      </a>
      <a href="tel:+4915773577671" aria-label="Maikes Familienbegleitung anrufen">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" role="img" aria-label="Telefon-Symbol">
          <path d="M20,24H4c-2.2,0-4-1.8-4-4V4c0-2.2,1.8-4,4-4h16c2.2,0,4,1.8,4,4v16C24,22.2,22.2,24,20,24z M4,3
            C3.4,3,3,3.4,3,4c0,9.4,7.6,17,17,17c0.6,0,1-0.4,1-1v-3.5c0-0.6-0.4-1-1-1c-1.2,0-2.4-0.2-3.6-0.6c-0.1,0-0.2-0.1-0.3-0.1
            c-0.3,0-0.5,0.1-0.7,0.3l-2.2,2.2c-1.4-0.7-2.7-1.7-3.8-2.8c-1.1-1.1-2.1-2.4-2.8-3.8l2.2-2.2c0.3-0.3,0.4-0.7,0.3-1
            C8.7,6.4,8.5,5.2,8.5,4c0-0.6-0.4-1-1-1H4z">
          </path>
        </svg>
      </a>
    </div>
  </footer>
</template>

<script>
  export default {
    name: 'Footer'
  }
</script>

<style scoped>
.footer {
  text-align: center;
  padding: 1.25rem; /* 20px */
  color: var(--secondary-font-color);
  background-color: var(--primary-color);
  margin-top: 1.25rem; /* 20px */
}

.footer-links {
  margin-bottom: 0.625rem; /* 10px */
}

.footer-links a {
  color: var(--secondary-font-color);
  text-decoration: none;
  margin: 0 0.3125rem; /* 0 5px */
}

.footer-links a:hover {
  text-decoration: underline;
}

.footer-copyright {
  margin-bottom: 0.625rem; /* 10px */
  color: var(--font-color-light);
}

.footer-social a {
  margin: 0 0.25rem; /* 0 4px */
}

.footer-social svg {
  fill: var(--secondary-font-color);
  width: 2.25rem; /* 36px */
  height: 2.25rem; /* 36px */
}
</style>